// extracted by mini-css-extract-plugin
export default {"container":"_37nDE6WjW0AFPJYNTPYip0"};